import { Link } from 'react-router-dom';
import { LibraryObjectActionsMenu } from './LibraryObjectActionsMenu';

export interface LibraryObjectCardItem {
  id: string;
  title: string;
  name?: string;
  type?: string;
  typeLabel?: string;
  status?: string;
  statusLabel?: string;
  thumbnailUrl?: string;
  versionCount?: number;
  usageCount?: number;
  sectionItems?: unknown[];
  currentVersion?: { versionNumber?: number };
}

const TYPE_ICONS: Record<string, string> = {
  video: 'play_circle',
  pdf: 'picture_as_pdf',
  pdf_folder: 'folder',
  image: 'image',
  audio: 'audio_file',
  download: 'download',
  html: 'code',
  rich_text: 'article',
  external_link: 'link',
  h5p: 'extension',
  assessment: 'quiz',
  scorm: 'inventory_2',
  xapi: 'inventory_2',
  cmi5: 'inventory_2',
};

const STATUS_CLASS: Record<string, string> = {
  published: 'lib-card-badge lib-card-badge--published',
  draft: 'lib-card-badge lib-card-badge--draft',
  archived: 'lib-card-badge lib-card-badge--archived',
};

interface LibraryObjectCardProps {
  item: LibraryObjectCardItem;
}

export function LibraryObjectCard({ item }: LibraryObjectCardProps) {
  const icon = TYPE_ICONS[item.type ?? ''] ?? 'inventory_2';
  const showUrl = `/library/${item.id}`;
  const displayName = item.name ?? item.title;
  const courseCount = item.usageCount ?? item.sectionItems?.length ?? 0;
  const versionCount = item.versionCount ?? item.currentVersion?.versionNumber ?? 1;
  const statusClass = STATUS_CLASS[item.status ?? ''] ?? STATUS_CLASS.draft;

  return (
    <article className="lib-object-card group">
      <Link to={showUrl} className="lib-object-card__media">
        {item.thumbnailUrl ? (
          <img src={item.thumbnailUrl} alt="" className="lib-object-card__thumb" />
        ) : (
          <div className="lib-object-card__thumb lib-object-card__thumb--placeholder" />
        )}
        <div className="lib-object-card__media-icon" aria-hidden="true">
          <span className="material-symbols-outlined text-[2rem] text-dash-primary">{icon}</span>
        </div>
      </Link>

      <div className="lib-object-card__body">
        <div className="mb-3 flex items-center justify-between gap-2">
          {item.type && <span className="lib-card-badge lib-card-badge--type">{item.typeLabel ?? item.type}</span>}
          {item.status && <span className={statusClass}>{item.statusLabel ?? item.status}</span>}
        </div>

        <h3 className="lib-object-card__title">
          <Link to={showUrl} className="line-clamp-2 group-hover:text-dash-primary">
            {displayName}
          </Link>
        </h3>

        <div className="lib-object-card__footer">
          <span>
            v{versionCount} · {courseCount} {courseCount === 1 ? 'curso' : 'cursos'}
          </span>
          <LibraryObjectActionsMenu objectId={item.id} objectName={displayName} courseCount={courseCount} />
        </div>
      </div>
    </article>
  );
}
